import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsDownLeftChevronCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.657 13.657A8 8 0 1 0 2.343 2.343a8 8 0 0 0 11.314 11.314M8 3.05L4.818 6.232v4.95h4.95L12.95 8H8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsDownLeftChevronCircle
